import React, { useState, useEffect, useRef } from "react";
import Header from "../../common/HeaderAfterLogin";
import BackBar from "../home/BackBar";
import { useTranslation } from "react-i18next";
import { getData, postData } from "../../Service/ApiMethod";
import MessageBox from "./MessageBox";
import {
  baseUrl,
  JOBSEEKER_CHATS,
  Last_Message,
  Recomended_Messages,
  Recruiter_Create_Message,
  Recruiter_Get_Chats,
  RECURITER_PROFILE,
  RECURITER_STOREMESSAGES,
  Reset_counter,
  SEND_MESSAGE,
} from "../../Service/service";
import InputEmoji from 'react-input-emoji';
import moment from "moment";
import { initializeApp } from 'firebase/app';
import { getFirestore,collection, getDocs,addDoc,query,orderBy,serverTimestamp} from 'firebase/firestore';

// const firebaseConfig = {
//   apiKey: 'AIzaSyAqITxSsp6eE_fLwm6ppr22VRBHk0dOUTw',
//   authDomain: 'catzapptestaccount.firebaseapp.com',
//   projectId: 'catzapptestaccount',
//   storageBucket: 'catzapptestaccount.appspot.com',
//   messagingSenderId: '756639348164',
//   appId: '1:756639348164:web:0ee0ef67fd38abfa13e091',
// };

const firebaseConfig = {
  apiKey: "AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk",
  authDomain: "catzapp-391806.firebaseapp.com",
  projectId: "catzapp-391806",
  storageBucket: "catzapp-391806.appspot.com",
  messagingSenderId: "1090322864570",
  appId: "1:1090322864570:web:726e4ccd8f7630a00de583",
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];


const Messages = () => {
  const [AllUnlocked, setAllUnlocked] = useState(true)
  const [round, setRound] = useState(false)
  const [unRound, setUnRound] = useState(false)
  const [firstRound, setFirstRound] = useState(false)
  const [secondRound, setSecondRound] = useState(false)
  const [selectedRound, setSelectedRound] = useState(false)
  const [rejectedRound, setRejectedRound] = useState(false)
  const [candidates, setCandidates] = useState();
  const [reset, setReset] = useState()
  const [unread, setunread] = useState(false)
  const [chatBoxOpen, setChatBoxOpen] = useState(false);
  const [searchKey, setSearchKey] = useState()
  const [search, setSearch] = useState(false)
  const [unreadData, setUnreadData] = useState()
  const [filteredData, setFilteredData] = useState()
  const [dataa, setDataa] = useState(false)
  const [idOfJobseeker, setIdOfJobseeker] = useState();
  const [recruiterID, setRecruiterID] = useState();
  const [jobSeekerName, setJobSeekerName] = useState();
  const [jobseekerImage, setJobseekerImage] = useState();
  const [lastMessage, setLastMessage] = useState();
  const [unreadCount, setUnreadCount] = useState();
  const [lastSent, setLastSent] = useState();
  const [sentTime, setSentTime] = useState();
  const [timeDifference, setTimeDifference] = useState()
  const [updated, setUpdated] = useState()
  const [lastSeen, setLastSeen] = useState()
  const [idd, setIdd] = useState()
  const [searchData, setSearchData] = useState(false)
  const { width } = useWindowDimensions();
  const [chatMsgList, setChatMsgList] = useState([]);
  const [recruiterProfileData, setRecruiterProfileData] = useState();
  const [recomendedMsg, setRecomendedMsg] = useState([])
  const [text, setText] = useState('')
  const [msgName, setMsgName] = useState(" ");
  const [popup, setPopup] = useState(false)
  const [msgSended, setMsgSended] = useState("");

  const { t } = useTranslation();
  const bottomRef = useRef(null);

  useEffect(() => {
    jobseekerMsgBox();

  }, []);

  useEffect(() => {
    jobseekerMsgBox()
  }, [reset])

  useEffect(() => {
    getDetail()
  }, [])



  useEffect(() => {
    jobseekerMsgBox()
    getCloudMessageList()
  }, [])

  useEffect(() => {
    RecomendedMessage()
  }, [])

  // const scrollToBottom = () => {
  //   bottomRef.current.scrollIntoView({ behavior: 'smooth' });
  // };
    const RecomendedMessage = () => {
    getData(Recomended_Messages)
      .then((resp) => resp.json())
      .then((data) => {
        setRecomendedMsg(data?.data);
        console.log('recomended msg', data.data);
      })
      .catch((err) => {
        console.log("Error ", err);

      });
  }





  const getDetail = () => {
    getData(RECURITER_PROFILE)
      .then((response) => response.json())
      .then((res) => {
        setRecruiterProfileData(res.data);
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
      });
  };




  const getCloudMessageList = async () => {
    console.log("okkkkkkkk")
    // try {
    //   const docid = idOfJobseeker > recruiterProfileData?.user?.id
    //   ? recruiterProfileData?.user?.id + '-' + idOfJobseeker
    //   : idOfJobseeker + '-' + recruiterProfileData?.user?.id;
    //   const querySnapshot = await getDocs(collection(db, `JobseekerChatRoom/${docid}/messages`));
    //   console.log(querySnapshot,"cjjjjjjjjs")
    //   // querySnapshot.forEach((doc) => {
    //   //   console.log(doc.id, ' => ', doc.data());
    //   // });
    // } catch (error) {
    //   console.error('Error fetching data: ', error);
    // }
    try {

        // Calculate the Firestore path based on idOfJobseeker and recruiterProfileData
        const docid = idOfJobseeker > recruiterProfileData?.user?.id
          ? `${recruiterProfileData?.user?.id}-${idOfJobseeker}`
          : `${idOfJobseeker}-${recruiterProfileData?.user?.id}`;

        // Query Firestore to get chat messages ordered by createdAt
        const messagesRef = query(
          collection(db, `JobseekerChatRoom/${docid}/messages`),
          orderBy('createdAt', 'asc')
        );
        console.log(messagesRef,"message2")
        const querySnapshot = await getDocs(messagesRef);
        console.log(querySnapshot,"message1")
        // Extract and map the data from Firestore documents
        const messagesData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Update the chatMsgList state if there are new messages
        if (messagesData.length !== chatMsgList.length) {
          console.log(messagesData,"message222222222")
          setChatMsgList(messagesData);
        }
      // const docid = idOfJobseeker > recruiterProfileData?.user?.id
      //   ? recruiterProfileData?.user?.id + '-' + idOfJobseeker
      //   : idOfJobseeker + '-' + recruiterProfileData?.user?.id;
      //   console.log(docid,"message5")
      // let msgList = [];
      // const messagesRef = query(collection(db, `JobseekerChatRoom/${docid}/messages`), orderBy('createdAt', 'asc'));
      // console.log(messagesRef,"message2")
      // const querySnapshot = await getDocs(messagesRef);
      // console.log(querySnapshot,"message1")
      // querySnapshot?.forEach((doc, i) => {
      //   msgList[i] = doc?.data();
      // });
      // if (msgList?.length !== chatMsgList?.length) {
      //   console.log(msgList,"message")
      //   setChatMsgList(msgList);
      // }
    } catch (err) {
      console.log(err,"err022");
    }
  };




  function getWindowDimensions() {
    const { innerWidth: width } = window;
    return {
      width
    };
  }


  function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );

    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
  }

  
  const MessageResetCounter = (id) => {
    const obj = {
      jobseeker_id: id
    }
    postData(obj, Reset_counter)
      .then((res) => res.json())
      .then((res) => {
        console.log(res, "resetcounter");
        setReset(res?.data);
      })
  };

  const jobseekerMsgBox = () => {
    getData(Recruiter_Get_Chats)
      .then((res) => res.json())
      .then((res) => {
        console.log(res?.data, "get chats list");
        setCandidates(res?.data);
        setTimeout(()=>{
          scrollToBottom();
        },1000)
        getCloudMessageList()
      })
  };


  const onSearch = () => {

    let temp = [...candidates];
    if (searchKey) {
      const newData = temp?.filter((item) => (item?.jobseeker_name?.toLowerCase()?.includes(searchKey?.toLowerCase())))
      console.log('newData', newData)
      setSearchData(newData)
      setUnRound(false)
      setAllUnlocked(false)
      setRound(false)
      setSearch(true)
      setChatBoxOpen(false)
      setunread(false)

    }
    else {
      alert("Please Enter a value")

    }

  }


  const handleUnread = () => {
    const filterArray = candidates?.filter((item) => item?.unread_count !== 0)

    setUnreadData(filterArray)
    setUnRound(true)
    setAllUnlocked(false)
    setRound(false)
    setSearch(false)



  }
  

  const handleRoundData = (round_name) => {
    const filterArray = candidates?.filter((item) => item?.round_status === round_name)

    setFilteredData(filterArray);
    setAllUnlocked(false)
    setRound(true)
    setUnRound(false)
    setSearch(false)

  }




  const inputRef = useRef(null);

  function handleClick() {
    inputRef.current.value = '';
  }


  function handleOnEnter(text) {
    console.log('enter', text)

    sendMessage(msgName)
    handleClick()
  }

  const sendMessage = async () => {


    if (msgName != '') {

      setMsgSended(msgName);
      setMsgName("");
      const sendId = parseInt(idOfJobseeker);

      // const messageList = chatMsgList;
      let newMessage = {
        text: msgName,
        sentBy: parseInt(recruiterProfileData?.user?.id),
        sentTo: sendId,
        createdAt: new Date(),
      };
      // const obj = {
      //   query_id: parseInt(idOfJobseeker),
      //   data: messageList,
      // };

      const docid =
        sendId > recruiterProfileData?.user?.id
          ? recruiterProfileData?.user?.id + '-' + sendId
          : sendId + '-' + recruiterProfileData?.user?.id;

      // const queryDoc = doc(firestore, `JobseekerChatRoom/${docid}/messages`);
      // await setDoc(queryDoc, messageList)
      await addDoc(collection
        (db, `JobseekerChatRoom/${docid}/messages`), newMessage, serverTimestamp());

      fetch(baseUrl + Last_Message, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer  ${localStorage.getItem("catzapp_token")}`,
        },

        body: JSON.stringify({
          jobseeker_id: parseInt(idOfJobseeker),
          last_message: msgName,

          // msg_response: msgName,
        }),

      });

      getCloudMessageList();
      jobseekerMsgBox()
      handleKeyPress()

    }
    else {

    }
    // fetch("https://dev.jobportalapi.atwpl.com/recruiter/closeChat/", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: `Bearer  ${localStorage.getItem("token")}`,
    //   },
    //   body: JSON.stringify({
    //     jobseekerId: idOfJobseeker,
    //   }),
    // });
    // props.close();
    // Swal
  };


  const scrollEnd = useRef();
  const scrollContainerRef = useRef(null);

  const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        // Scroll to the bottom of the container when the Enter key is pressed
        scrollEnd.current.scrollTop = scrollEnd.current.scrollHeight;
      }
   
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);


  // useEffect(() => {
  //   scrollToBottom();
  // }, [chatMsgList]);

  const scrollToBottom = () => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Header />
      <div style={{ background: "#e9eef6" }}>
        <div className="wrapped-content-area wrapped-content-message-area pt-4">
          <BackBar title={t("Messages")} />
          <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
            <div
              className="search-container  flex-center relative"
            >
              <input
                type="text"
                placeholder={t("Search by Candidates/keywords")}
                className="search-input form-control"
                onChange={(e) => {
                  setSearchKey(e.target.value)

                }}
                onKeyDown={e => e.key === 'Enter' ? onSearch(searchKey) : ''}

              />
              <span onClick={() => onSearch(searchKey)} style={{ cursor: 'pointer' }}>
                <img src="./images/search.png" alt="search" className="searchIcon" />
              </span>
            </div>
          </div>
          <div className="container-fluid hashtags-keys-slider">

            <div className="hashtags-keys">
              <p className="filters">{t('Filters')}:- </p>
              <button className={AllUnlocked ? "active-tag " : "deactive-tags"}
                style={{ fontSize: "12px" }}
                onClick={() => {
                  setAllUnlocked(true)
                  setRound(false)
                  setUnRound(false)
                  setFirstRound(false)
                  setSelectedRound(false)
                  setRejectedRound(false)
                  setSecondRound(false)
                  setSearch(false)
                  setunread(false)

                  // setSearchData('')
                  setChatBoxOpen(false)

                }}

              >

                {t('All')}</button>

              <button
                className={unread ? "active-tag " : "deactive-tags"}
                style={{ fontSize: "12px" }}
                onClick={() => {
                  handleUnread()
                  setFirstRound(false)
                  setSelectedRound(false)
                  setRejectedRound(false)
                  setSecondRound(false)
                  setAllUnlocked(false)
                  setSearch(false)
                  setChatBoxOpen(false)
                  setunread(true)



                }}
              >
                {t('Unread')}
              </button>
              <button
                className={firstRound ? "active-tag " : "deactive-tags"}

                style={{ fontSize: "12px" }}
                onClick={() => {
                  handleRoundData('First Round')
                  setFirstRound(true)
                  setSelectedRound(false)
                  setRejectedRound(false)
                  setSecondRound(false)
                  setAllUnlocked(false)
                  setSearch(false)
                  setChatBoxOpen(false)
                  setunread(false)


                }}



              >
                {t('First Round')}
              </button>
              <button
                className={secondRound ? "active-tag " : "deactive-tags"}

                style={{ fontSize: "12px" }}
                onClick={() => {

                  handleRoundData('Second Round')
                  setFirstRound(false)
                  setSelectedRound(false)
                  setRejectedRound(false)
                  setSecondRound(true)
                  setAllUnlocked(false)
                  setSearch(false)
                  setChatBoxOpen(false)
                  setunread(false)


                }}
              >
                {t('Second Round')}
              </button>
              <button
                className={rejectedRound ? "active-tag " : "deactive-tags"}
                style={{ fontSize: "12px" }}
                onClick={() => {
                  setunread(false)

                  handleRoundData('Rejected')
                  setFirstRound(false)
                  setSelectedRound(false)
                  setRejectedRound(true)
                  setSecondRound(false)
                  setAllUnlocked(false)
                  setSearch(false)
                  setChatBoxOpen(false)

                }}
              >
                {t('Rejected')}
              </button>
              <button

                style={{ fontSize: "12px" }}
                className={selectedRound ? "active-tag " : "deactive-tags"}
                onClick={() => {

                  handleRoundData('Selected')
                  setFirstRound(false)
                  setSelectedRound(true)
                  setRejectedRound(false)
                  setSecondRound(false)
                  setAllUnlocked(false)
                  setSearch(false)
                  setChatBoxOpen(false)
                  setunread(false)


                }}
              >
                {t('Selected')}
              </button>
            </div>

          </div>

          <div className="messages-chat">
            <div className="d-flex messages-chat-inner">
              {AllUnlocked ? (
                <div
                  className={
                    width > 767
                      ? "col-5 px-0 message-area"
                      : "col-12 px-0  message-area"
                  }
                // style={{ background: "#e9eef6" }}
                >
                  {candidates?.length !== 0 ?
                    candidates?.map((item, i) => {

                      return (
                        <>
                          <MessageBox
                            jobSeekerDetails={item}
                            reset={reset}
                            dataa={dataa}
                            setDataa={setDataa}

                            // jobseeker_id={item?.jobseeker_id}
                            // jobseeker_name={item?.jobseeker_name}
                            // jobseeker_image={item?.jobseeker_image}
                            // jobseekerLastmsg={item?.last_message}
                            openChatWindow={() => {
                              jobseekerMsgBox()
                              setChatBoxOpen(true);
                             
                              setIdOfJobseeker(item?.jobseeker_id);
                              setRecruiterID(item?.recruiter)
                              setJobSeekerName(item?.jobseeker_name)
                              setJobseekerImage(item?.jobseeker_image)
                              setLastMessage(item?.last_message)
                              setUnreadCount(item?.unread_count)
                              setLastSent(item?.last_sent)
                              setSentTime(item?.updated_at)
                              setTimeDifference(item?.time_difference)
                              setUpdated(item?.updated_at)
                              setLastSeen(item?.last_seen)
                              setIdd(item?.id)
                              MessageResetCounter(item?.jobseeker_id)
                             


                            }}
                          />
                        </>
                      );
                    }) :
                    <div className="message-area-inneer" style={{  }}>{t('No Messages Found')}</div>}
                </div>
              ) : null}

              {unRound ? (
                <div
                  className={
                    width > 767
                      ? "col-5 px-0  message-area"
                      : "col-12 px-0 message-area"
                  }
                  style={{}}
                >
                  {unreadData.length !== 0 ?
                    unreadData?.map((item, i) => {

                      return (
                        <>
                          <MessageBox className="message-box-container"
                            jobSeekerDetails={item}
                            dataa={dataa}
                            setDataa={setDataa}

                            // jobseeker_id={item?.jobseeker_id}
                            // jobseeker_name={item?.jobseeker_name}
                            // jobseeker_image={item?.jobseeker_image}
                            // jobseekerLastmsg={item?.last_message}
                            openChatWindow={() => {
                              jobseekerMsgBox()
                              setChatBoxOpen(true);
                              setIdOfJobseeker(item?.jobseeker_id);
                              setRecruiterID(item?.recruiter)
                              setJobSeekerName(item?.jobseeker_name)
                              setJobseekerImage(item?.jobseeker_image)
                              setLastMessage(item?.last_message)
                              setUnreadCount(item?.unread_count)
                              setTimeDifference(item?.time_difference)
                              setUpdated(item?.updated_at)
                              setLastSeen(item?.last_seen)
                              setIdd(item?.id)
                              MessageResetCounter(item?.jobseeker_id)






                            }}
                          />
                        </>
                      );
                    }) :
                    <div className="message-area-inneer" style={{  }}>{t('No Messages Found')} </div>}
                </div>
              ) : null}

              {round ? (
                <div
                  className={
                    width > 767
                      ? "col-5 px-0  message-area"
                      : "col-12 px-0  message-area"
                  }
                  style={{}}
                >
                  {filteredData?.length !== 0 ?
                    filteredData?.map((item, i) => {

                      return (
                        <>
                          <MessageBox
                            jobSeekerDetails={item}
                            dataa={dataa}
                            setDataa={setDataa}

                            // jobseeker_id={item?.jobseeker_id}
                            // jobseeker_name={item?.jobseeker_name}
                            // jobseeker_image={item?.jobseeker_image}
                            // jobseekerLastmsg={item?.last_message}
                            openChatWindow={() => {
                              jobseekerMsgBox()
                              setChatBoxOpen(true);
                              setIdOfJobseeker(item?.jobseeker_id);
                              setRecruiterID(item?.recruiter)
                              setJobSeekerName(item?.jobseeker_name)
                              setJobseekerImage(item?.jobseeker_image)
                              setLastMessage(item?.last_message)
                              setUnreadCount(item?.unread_count)
                              setTimeDifference(item?.time_difference)
                              setUpdated(item?.updated_at)
                              setLastSeen(item?.last_seen)
                              setIdd(item?.id)
                              MessageResetCounter(item?.jobseeker_id)






                            }}
                          />
                        </>
                      );
                    }) : <div className="message-area-inneer"  style={{  }}>{t('No Messages Found')}</div>}
                </div>
              ) : null}

              {search ? (
                <div
                  className={
                    width > 767
                      ? "col-5 px-0  message-area"
                      : "col-12 px-0  message-area"
                  }
                  style={{ background: "#fff" }}
                >
                  {searchData?.length !== 0 ?
                    searchData?.map((item, i) => {

                      return (
                        <>
                          <MessageBox
                            jobSeekerDetails={item}

                            dataa={dataa}
                            setDataa={setDataa}
                            openChatWindow={() => {
                              jobseekerMsgBox()
                              setChatBoxOpen(true);
                              setIdOfJobseeker(item?.jobseeker_id);
                              setRecruiterID(item?.recruiter)
                              setJobSeekerName(item?.jobseeker_name)
                              setJobseekerImage(item?.jobseeker_image)
                              setLastMessage(item?.last_message)
                              setUnreadCount(item?.unread_count)
                              setTimeDifference(item?.time_difference)
                              setUpdated(item?.updated_at)
                              setLastSeen(item?.last_seen)
                              setIdd(item?.id)
                              MessageResetCounter(item?.jobseeker_id)






                            }}
                          />
                        </>
                      );
                    }) :

                    <div className="message-area-inneer" style={{  }}>{t('No Messages Found')}</div>}
                </div>
              ) : null}

{chatBoxOpen && (width > 300) ?
                <div
                  className={width > 767 ? "col-7 chat-area" : "col-12 chat-area"}
                  
                >


                  <div className="chat-section-box"  >
                    <div className="fix-chat-header">
                      {/* <img
                    src="./images/white-backbtn.png"
                    onClick={() => {
                      props.onClose();
                    }}
                    alt=""
                    className="backImg mr-3 chat-back-arrow-header"
                  /> */}

                      <span className="chat-user-name">{jobSeekerName} </span>


                      {
                        parseInt(lastSeen) == 0 ?
                          <span className="lastseen"><span className="dotOn"> </span> online </span> :
                          <span className="lastseen"> {t('Last Seen')} {lastSeen} {t('ago')}  </span>}


                    </div>

                    <div className="wrapped-message-area"
                      onContentSizeChange={() =>
                        scrollEnd.current.scrollToEnd({ animated: true })
                      } 
                      
                        >
                      <div className="chat"   style={{overflowY: "scroll"}}  >






                        {/* Recieve Box */}
                        {/* <div className="d-flex">
                        <img
                          src={jobseekerImage}
                          alt=""
                          className="sender-img mr-1"
                        />
                        <div className="recieve-msg-box">
                          <h3 className="sender-name">{jobSeekerName}</h3>
                          <p className="text mt-2">
                            {lastMessage}
                          </p>
                        </div>
                      </div> */}


                        {/* Chat Send Box */}
                        {chatMsgList?.map((item, index) => {


                          const nanoseconds = item?.createdAt?.nanoseconds
                          const seconds = item?.createdAt?.seconds


                          const timestamp = seconds * 1000 + nanoseconds / 1000000; // Combine seconds and nanoseconds
                          const createdAtDate = new Date(timestamp); // Convert to date object

                          const DateTitle = moment(createdAtDate).format('YYYY-MM-DD'); // Format date using moment.js
                          const month = monthNames[createdAtDate.getMonth()];
                          const date = createdAtDate.getDate();
                          const year = createdAtDate.getFullYear();
                          const dateFormat = date + ' ' + month + ' ' + year;
                          const todayDateFormat = moment(new Date()).format('YYYY-MM-DD');

                          let previousObjDate;
                          if (index !== 0) {
                            const prevSeconds = chatMsgList[index - 1].createdAt.seconds;
                            const prevNanoseconds = chatMsgList[index - 1].createdAt.nanoseconds;
                            const prevTimestamp = prevSeconds * 1000 + prevNanoseconds / 1000000;
                            const prevDate = new Date(prevTimestamp);
                            previousObjDate = moment(prevDate).format('YYYY-MM-DD');
                          }

                          // console.log(DateTitle, month, date, year, "26362737828828");

                          console.log(DateTitle, month, date, year, seconds, nanoseconds, "26362737828828")





                          return (
                            <>
                              {/* // console.log('chatMsgListssss', item);

                          // console.log('item sent', item?.createdAt?.nanoseconds) */}

                              <div className="flex-center w-100 relative" >
                                <hr className="days-update-line" />
                                <div>
                                  {
                                    index !== 0 && DateTitle === previousObjDate ? null : (
                                      <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '10px' }}>
                                        {DateTitle === todayDateFormat ? 'Today' : dateFormat}</span>


                                    )}</div>
                                <hr className="days-update-line" />
                              </div>



                              {(item.sentBy == recruiterProfileData?.user?.id) ?


                                <>
                                  <div className="d-flex justify-content-end" key={index}>
                                    <div className="send-msg-box" >
                                      <h3 className="sender-name" style={{ color: '#0d3068' }}>{recruiterProfileData?.first_name}</h3>
                                      <p className="text mt-2 break-para">{item.text}</p>
                                    </div>
                                    <img
                                      src={(recruiterProfileData?.image) || "./images/Vector.png"}
                                      alt=""
                                      className="sender-img ml-1 mr-1"
                                    />

                                  </div>


                                  <span
                                    style={{
                                      display: "flex",
                                      justifyContent: "end",
                                      paddingRight: 10,
                                      fontSize: '9px'
                                    }} className="mx-2">{moment.unix(item?.createdAt).format('hh:mm A')}</span>

                                </> :
                                <>
                                  <div className="d-flex">
                                    <img
                                      src={jobseekerImage}
                                      alt=""
                                      className="sender-img mr-1"
                                    />
                                    <div className="recieve-msg-box">
                                      <h3 className="sender-name">{jobSeekerName}</h3>
                                      <p className="text mt-2">
                                        {item?.text}

                                      </p>

                                    </div>


                                  </div>
                                  <span
                                    style={{
                                      paddingLeft: '45px',
                                      fontSize: '9px'
                                    }} className="mx-2">{moment.unix(item?.createdAt).format('hh:mm A')}</span>

                                </>
                              }

                            </>
                          )
                        }


                        )}
                          <div ref={bottomRef}></div>
                      </div>
                    
                    </div>
                    <div className="send-input-box">
                      <div className="relative">

                        <img
                          src="./images/MSG.png
                          "
                          alt="hello"
                          className="right-img"
                          style={{
                            height: '20px',
                            zIndex: '9',
                            right: '57px',
                            top: '17px',
                          }}

                          onClick={() => {
                            setPopup(true)
                          }}


                        />

                        <InputEmoji
                          multiselect
                          value={text}
                          maxLength={1499}
                          onChange={setMsgName}
                          ref={inputRef}

                          onEnter={handleOnEnter}
                          placeholder="Type a message"
                        // onKeyDown={e => e.key === 'Enter' ? handleOnEnter() : ''}
                        />


                        {
                          popup &&

                          <div className="blur-screen-full-area flex-center" >
                            <div className="edit-profile" >

                              {recomendedMsg != null ?
                                (recomendedMsg?.map?.((item, index) => {

                                  const rec = item?.message
                                  return (
                                    <div className='d-flex rec-msg-outer'>
                                      <div key={index} className='col-12 rec-msg ' style={{
                                        border: '1px solid black', borderRadius: '6px', height: '10vh', marginBottom: '10px'
                                      }}

                                        onClick={(e) => {
                                          e.stopPropagation()
                                          setPopup(!popup)
                                          setText(item?.message)
                                          setMsgName(item?.message)

                                        }}
                                      >

                                        {rec}


                                      </div>
                                    </div>



                                  )
                                }
                                )


                                ) : <> {t('No Data Found')}</>
                              }


                            </div>
                          </div>
                        }
                        {/* <input

                          maxLength={1499} required="true"
                          type='textarea'
                          placeholder="Type a message"


                          className="send-input"
                          onChange={(e) => {

                            handleChange(e);
                            // setFieldValue(e.target.value)
                          }}
                          // onKeyDown={handleKeyDown}

                          value={msgName || emo }
                        /> */}




                        {/* <img
                          src="./images/camera.png"
                          alt=""
                          className="right-img"
                        /> */}
                      </div>

                      {/* {
                        emoji && <div style={{ position: 'absolute', zIndex: '99999999', bottom: '55px' }}>


                          <Picker onSelect={handleEmojiSelect} />
                           <EmojiPicker  onEmojiClick={handleEmojiClick}  height={300} width={300} />
                         
                        </div>
                      } */}

                      <button className="send-btn" onClick={() => {

                        sendMessage(msgName)
                        handleClick()
                       
                      }
                      }
                      >
                        <img
                          src="./images/send-msg.png"
                          alt=""
                          className="send-img"
                        />
                      </button>
                    </div>
                  </div>







                </div>
                : null}

            </div>
          </div>

        </div>

      </div >

    </>
  );
};

export default Messages;
